module.exports = __webpack_public_path__ + "img/pic_tltw_ewmsy_selected@2x.a1ae817b.png";